import type { FormInstance } from 'antd';
import type { TFunction } from 'i18next';

type MessageApi = { error: (content: string) => void };

/**
 * Maps a customer create/update API error to inline form-field errors (or a
 * toast for non-field errors). Single home for this mapping, shared by the list
 * create modal and the detail-page edit form.
 */
export function applyCustomerSaveError(
  error: any,
  form: FormInstance,
  t: TFunction,
  message: MessageApi
): void {
  const serverMessage = error?.response?.data?.message;
  const serverCode = error?.response?.data?.code;
  const existingName = error?.response?.data?.existingCustomerName;

  if (serverCode === 'STATUS_EMAILS_REQUIRE_EMAIL') {
    form.setFields([
      { name: 'sendOrderStatusEmails', errors: [t('customers:messages.statusEmailsRequireEmail')] }
    ]);
  } else if (serverCode === 'STALE_CUSTOMER_CATEGORY') {
    form.setFields([
      { name: 'customerCategoryId', errors: [t('customers:customerCategory.staleCategory')] }
    ]);
  } else if (serverMessage === 'Customer with this name already exists') {
    form.setFields([{ name: 'name', errors: [t('customers:messages.nameExists', { name: existingName || '?' })] }]);
  } else if (serverMessage === 'Customer with this tax ID already exists') {
    form.setFields([{ name: 'taxId', errors: [t('customers:messages.taxIdExists', { name: existingName || '?' })] }]);
  } else if (serverMessage === 'Customer with this REGON already exists') {
    form.setFields([{ name: 'regon', errors: [t('customers:messages.regonExists', { name: existingName || '?' })] }]);
  } else if (serverMessage === 'Customer with this email already exists') {
    form.setFields([{ name: 'email', errors: [t('customers:messages.emailExists', { name: existingName || '?' })] }]);
  } else if (serverMessage === 'Branch customer must have parent company selected') {
    form.setFields([{ name: 'parentCustomerId', errors: [t('customers:messages.parentRequired')] }]);
  } else if (
    serverMessage === 'Parent customer not found' ||
    serverMessage === 'Branch cannot use another branch as parent company' ||
    serverMessage === 'Parent customer must have tax ID before adding branches'
  ) {
    form.setFields([{ name: 'parentCustomerId', errors: [t('customers:messages.parentInvalid')] }]);
  } else if (
    serverMessage === 'Customer with active branches cannot become a branch' ||
    serverMessage === 'Parent customer with active branches must keep tax ID'
  ) {
    message.error(t('customers:messages.branchConfigurationBlocked'));
  } else {
    message.error(t('customers:messages.saveFailed'));
  }
}
